import { Box, Typography } from "@mui/material";
import CustomToolTip from "../../../../components/CustomTooltip";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { Platforms, ServerOS } from "../../../../utils/constants";
import { getHostLastSeenTimestamp } from "../../../../utils/search";
import { getPrettyDate } from "../../../../utils/timestamp";
import {
  getMacOSName,
  getWindowsOSName,
} from "../components/entitiesCharts/hostChart/osVersionDistribution/osVersionHelpers";
import { platformIcons } from "../utils";

export const getHostColumns = (colors, showLocalTime = true) => ({
  os: {
    field: "os",
    headerName: "OS",
    minWidth: 110,
    flex: 1,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    valueGetter: (params) =>
      params.row.os_version || params.row.platform || null,
    renderCell: (params) => {
      if (!params.value) return <Typography variant="caption">-</Typography>;

      // Check if this is a Windows Server
      const isWindowsServer = params.row.server_os === ServerOS.WINDOWS_SERVER;
      const displayText = isWindowsServer
        ? ServerOS.WINDOWS_SERVER
        : params.row.platform === Platforms.WINDOWS
        ? getWindowsOSName(params.value)
        : params.row.platform === Platforms.MACOS
        ? getMacOSName(params.value)
        : params.value;

      // Use Windows platform icon for Windows Server
      const platformForIcon = isWindowsServer
        ? Platforms.WINDOWS
        : params.row.platform;

      if (!platformIcons[platformForIcon]) {
        return (
          <Box display="flex" alignItems="center">
            <Typography variant="caption">{displayText}</Typography>
          </Box>
        );
      }

      return (
        <Box display="flex" alignItems="center" gap={1}>
          <CustomToolTip
            title={
              isWindowsServer ? ServerOS.WINDOWS_SERVER : params.row.platform
            }
          >
            <span>
              <SvgToIcon
                IconLogo={platformIcons[platformForIcon]}
                width={"24px"}
              />
            </span>
          </CustomToolTip>
          <Typography variant="caption">{displayText}</Typography>
        </Box>
      );
    },
  },
  connected_user: {
    field: "connected_user_name",
    headerName: "Connected User",
    minWidth: 185,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    renderCell: (params) => (
      <Box sx={{ cursor: "pointer" }}>
        <Typography variant="caption">{params.value || "-"}</Typography>
      </Box>
    ),
  },
  last_seen: {
    field: "last_seen",
    headerName: "Last Seen",
    minWidth: 100,
    flex: 1,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    valueGetter: (params) => getHostLastSeenTimestamp(params.row),
    valueFormatter: (params) =>
      getPrettyDate(params.value, showLocalTime) || null,
    renderCell: (params) => (
      <Typography variant="caption" color={colors.grey_700}>
        {params.value ? getPrettyDate(params.value, showLocalTime) : "-"}
      </Typography>
    ),
  },
  vulnerabilities: {
    field: "vulnerability_count",
    headerName: "Vulnerabilities",
    minWidth: 140,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    valueGetter: (params) => {
      return params.row.vulnerability_count || 0;
    },
    valueFormatter: (params) => params.value.toString(),
    renderCell: (params) => (
      <Typography variant="caption">{params.value}</Typography>
    ),
  },
});
